import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import clsx from "clsx";
import { PackageCarFilterDialog } from "./PackageCarFilterDialog";
import { PackageCarFilterList } from "./PackageCarFilterList";
import defaultStyles from "./PackageCarFilters.module.scss";
import { useCarsStyles } from "~core-cars/themes";
import { CoreCarsComponent } from "~core-cars/types";

const COMPONENT_KEY = CoreCarsComponent.Filters;

/**
 * Package-specific car filters component that uses incremental pricing
 * Includes both mobile FilterDialog and desktop FilterList
 */
export const PackageCarFilters = ({
  className,
  children,
}: PlatformComponentProps) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <div className={clsx(block, className)}>
      <PackageCarFilterDialog />
      <PackageCarFilterList className={cn("list")} />
      {children}
    </div>
  );
};
